"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quickswap = void 0;
exports.quickswap = {
    router: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff", // UniswapV2Router02
};
